<!--
 * @Description: 登陆渠道
 * @Author: cooky
 * @Date: 2021-02-25 17:17:56
 * @LastEditors: cooky
 * @LastEditTime: 2021-05-11 14:26:38
-->
<template>
  <div class="third_channel">
    <a
      class="channel"
      v-for="(channel, index) in channelImgs"
      :key="index"
      :href="channel.url"
      :class="channel.class"
      :style="{ backgroundImage: 'url(' + channel.bgUrl + ')' }"
    >
      <span>{{ channel.title }}</span>
    </a>
  </div>
</template>
<script>
import { GOOGLE_AUTH, FB_AUTH } from '@/config/universal'
import { mapState } from 'vuex'
// import Store from '@/store'

export default {
  name: 'ThirdPartChannel',
  async beforeRouteEnter (to, from, next) {
    window.sessionStorage.clear()
    next()
  },
  computed: {
    ...mapState(['isPc']),
    channelImgs () {
      return this.isPc ? (
        [
          {
            alt: 'google',
            url: GOOGLE_AUTH,
            title: this.$t('google_login'),
            class: 'btn-google',
            bgUrl: require('../static/assets/ui/pc/btn-google.png')
          },
          {
            alt: 'facebook',
            url: FB_AUTH,
            title: this.$t('facebook_login'),
            class: 'btn-facebook',
            bgUrl: require('../static/assets/ui/pc/btn-facebook.png')
          }
        ]
      ) : (
        [
          {
            alt: 'google',
            url: GOOGLE_AUTH,
            title: this.$t('google_login'),
            class: 'btn-google',
            bgUrl: require('../static/assets/ui/pc/btn-google.png')
          },
          {
            alt: 'facebook',
            url: FB_AUTH,
            title: this.$t('facebook_login'),
            class: 'btn-facebook',
            bgUrl: require('../static/assets/ui/pc/btn-facebook.png')
          }
        ]
      )
    }
  }
}
</script>
<style lang="less" scoped>
  .third_channel {
    width: 465px;
    margin: 0 auto;
    padding-top: 45px;
    font-size: 22px;
    .channel {
      display: inline-block;
      width: 100%;
      height: 78px;
      border-radius: 6px;
      margin-bottom: 32px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      color: #fff;
      line-height: 78px;
      text-decoration: none;
      text-indent: 20px;
      text-align: center;
    }
    .btn-google {
      color: #515151;
    }
  }
  @media screen and (max-width: 750px) {
    .third_channel {
      width: 69.6rem;
      height: 13.8667rem /* 104/7.5 */;
      font-size: 3.7333rem;
      padding-top: 6.4rem;
      // flex-direction: column;
      // justify-content: space-between;
      // align-items: center;
      // flex-wrap: nowrap;
      .channel {
        height: 13.8667rem;
        line-height: 13.8667rem;
        margin-bottom: 6.4rem;
      }
    }
  }
</style>
